<template>
	<div>
		<div v-if="id">
			<pagetitle>{{ permission.name }} - Recht</pagetitle>
			<div class="row bg-white">
				<div class="col-12">
					<h2>Omschrijving:</h2>
					{{ permission.description }}
				</div>
			</div>
			<div class="row bg-white">
				<div class="col-12">
					<h2>Toegevoegd aan rollen:</h2>
					<ul>
						<li v-for="(role, index) in permission.roles"><a :href="'/role/'+role.id">{{ role.name }}</a></li>
					</ul>
				</div>
			</div>
		</div>
		<div v-else>
			<pagetitle>Rechten</pagetitle>
			<div class="row bg-white">
				<div class="col-12">
					<table class="table" v-if="permissionsresult">
						<thead>
							<tr>
								<th scope="col">Naam</th>
								<th scope="col">Omschrijving</th>
								<th scope="col"></th>
							</tr>
							<tr>
								<th scope="col"><input type="text" v-model="search.name" placeholder="naam" class="form-control"></th>
								<th scope="col"><input type="text" v-model="search.description" placeholder="omschrijving" class="form-control"></th>
								<th scope="col"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(permission, index) in permissionsresult" :key="index">
								<td>{{ permission.name }}</td>
								<td>{{ permission.description }}</td>
								<td><a :href="'/permission/'+permission.id" class="btn btn-theme">Open</a></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

name: 'permissions',
	props:{
		id:{
			required: false,
			default: false
		},
	},
	data () {
		return {
			'permissionid' 	: false,
			permissions 	: [],
			search 			: {},
			permission 		: {},
		}
	},
	computed:{
		permissionsresult : function(){
			// search permissions with name contain
			if(this.search.name){
				let search = this.search;
				let permissions = [];
				
				if(this.search.name.toLowerCase().length > 0){
					this.permissions.forEach(function(permission) {
						if(permission.name.toLowerCase().includes(search.name.toLowerCase())){
							permissions.push(permission);
						}
					});
					return permissions;
				}
			}

			return this.permissions;
		}
	},
	created(){
		if(this.id){
			this.$store.dispatch("get",this.$store.state.endpoint+'permissions/'+this.id+'?token='+this.$store.state.token)
		    .then(data=>{  
		        this.permission=data.data.data;
		        window.console.log('data',data.data.data);
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });
		}else{
		    this.$store.dispatch("get",this.$store.state.endpoint+'permissions?token='+this.$store.state.token)
		    .then(data=>{  
		        this.permissions=data.data.data;
		        window.console.log('data',data.data.data);
		       
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		        // window.console.log(error.request.response);
		    });
		}
	}
}
</script>

<style lang="css" scoped>
</style>